import { Empty, Spin } from 'antd';
import type { BrowseByTopicProps } from '../../types';
import styles from '../../AppHelpCenter.module.scss';
import BrowseByTopicCard from '../BrowseByTopicCard/BrowseByTopicCard';

const BrowseByTopic = ({ topics, loading, onSelect }: BrowseByTopicProps) => {
  return (
    <section className={styles.browseByTopic}>
      <h2 className={styles.browseByTopicTitle}>Browse by topic</h2>

      {loading ? (
        <div className={styles.helpSectionLoading}>
          <Spin />
        </div>
      ) : topics.length === 0 ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      ) : (
        <div className={styles.browseByTopicGrid}>
          {topics.map((topic) => (
            <BrowseByTopicCard
              key={topic.id}
              topic={topic}
              onSelect={onSelect}
            />
          ))}
        </div>
      )}
    </section>
  );
};

export default BrowseByTopic;
